import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface EyebrowPillProps {
  children: ReactNode;
  className?: string;
  dotColor?: string;
}

export function EyebrowPill({
  children,
  className,
  dotColor = 'bg-brand-300',
}: EyebrowPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2',
        'rounded-pill px-4 py-1.5',
        'bg-black/40 backdrop-blur-md',
        'border border-white/10',
        'text-eyebrow text-white/90',
        className
      )}
    >
      <span
        className={cn(
          'h-1.5 w-1.5 rounded-full',
          dotColor,
          'animate-pulse-soft shadow-[0_0_8px_currentColor]'
        )}
        aria-hidden
      />
      {children}
    </span>
  );
}
